import React from 'react';
import './BigTitle.css'; // Note the updated CSS import

// Renamed the function to BigTitle
const BigTitle = ({ text = '', show = false }) => {
  if (!show) return null;

  return (
    // Renamed the CSS class for clarity
    <h1 className="big-title-animation">{text}</h1>
  );
};

export default BigTitle;